import * as React from 'react';
import { Page, Grid, Card } from 'tabler-react';
import Tips from './Tips';
import AffiliateOverview from './Overview';
import Request from '../../shared/request';
import PageComponent from '../PageComponent';
import store from '../../shared/store';
import i18n from '../../shared/i18n';

import './affiliate.scss';

class Affiliate extends PageComponent {
  state = {
    bonuses: [],
    withdrawList: [],
    withdrawed: 0,
    balance: 0,
    recent: 0,
    affId: null,
  };

  constructor(props) {
    super(props);
    if (store.user && store.user.affId) {
      this.state.affid = store.user.affId;
    }
  }

  refreshAmount = async () => {
    const currentURL = window.location.origin;
    const affbuy = `${currentURL}/buy?affid=${this.state.affid}`;
    let newState = { affbuy };
    const data = await Request.call('getAffOrderList');
    if (data) {
      newState = {
        affbuy,
        withdrawed: data.amount.withdrawed,
        balance: data.amount.balance,
        recent: data.amount.recent,
        bonuses: data.list,
        users: data.count,
        nickname: data.nickname,
        texts: data.texts,
        affWithdrawAccount: data.affWithdrawAccount,
      };
      if (data.texts && data.texts.shareText1) {
        newState.shareText1 = `${data.texts.shareText1} ${affbuy}`;
      }
      if (data.texts && data.texts.shareText2) {
        newState.shareText2 = `${data.texts.shareText2} ${affbuy}`;
      }
    }
    const withdrawList = await Request.call('getAffWithdrawOrderList');
    if (withdrawList) {
      newState.withdrawList = withdrawList;
    }
    this.setState(newState);
  };

  updateState = (key, value) => {
    if (key) {
      const newstate = {};
      newstate[key] = value;
      this.setState(newstate);
    }
  };

  async componentDidMount() {
    this.refreshAmount();
    await store.dispatch({ type: 'updateUser' });
  }

  render() {
    return (
      <Page.Content className="affiliate">
        <Grid.Row>
          <Grid.Col lg={9}>
            <AffiliateOverview
              withdrawed={this.state.withdrawed}
              balance={this.state.balance}
              recent={this.state.recent}
              affid={this.state.affid}
              refreshAmount={this.refreshAmount}
              withdrawList={this.state.withdrawList}
              bonuses={this.state.bonuses}
              affWithdrawAccount={this.state.affWithdrawAccount}
            />
          </Grid.Col>
          <Grid.Col lg={3}>
            <Card>
              <Card.Header>
                <Card.Title>{i18n.t('dash-aff-notice')}</Card.Title>
              </Card.Header>
              <Card.Body className="contact">
                <p>
                {i18n.t('dash-aff-noticeintro')}
                </p>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>

        <Grid.Row>
          <Grid.Col xs={12} sm={12} md={12} lg={9}>
            <Card>
              <Tips
                affid={this.state.affid}
                nickname={this.state.nickname}
                shareText1={this.state.shareText1}
                shareText2={this.state.shareText2}
                updateState={this.updateState}
                affbuy={this.state.affbuy}
              />
            </Card>
          </Grid.Col>
          <Grid.Col xs={12} sm={12} md={12} lg={3}>
            <Card>
              <Card.Header>
                <Card.Title>{i18n.t('dash-aff-help')}</Card.Title>
              </Card.Header>
              <Card.Body className="qa">
                {/* <a href="/" className="btn-youtube" rel="noopener noreferrer">
                  <Icon name="play" /> 观看视频教程
                </a> */}
                <ul className="qr-list">
                  <li>
                    <a
                      href="https://getmalus.com/support/%E5%A6%82%E4%BD%95%E7%94%B3%E8%AF%B7Malus%E6%8E%A8%E8%8D%90%E8%BF%94%E7%8E%B0%E8%AE%A1%E5%88%92/28"
                      target="_blank"
                      rel="noopener noreferrer">
                      如何申请Malus返现计划?
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://getmalus.com/support/Malus%E6%8E%A8%E8%8D%90%E6%8F%90%E7%8E%B0%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98/29"
                      target="_blank"
                      rel="noopener noreferrer">
                      Malus推荐提现常见问题?
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://getmalus.com/support/%E5%A6%82%E4%BD%95%E9%AB%98%E6%95%88%E6%8E%A8%E5%B9%BFMalus%E4%BC%9A%E5%91%98%E8%8E%B7%E5%BE%97%E8%BF%94%E7%8E%B0/30"
                      target="_blank"
                      rel="noopener noreferrer">
                      如何高效推广Malus会员获得返现?
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://getmalus.com/support/%E5%A6%82%E4%BD%95%E6%9F%A5%E7%9C%8B%E6%94%B6%E7%9B%8A%E5%92%8C%E6%8F%90%E7%8E%B0/31"
                      target="_blank"
                      rel="noopener noreferrer">
                      如何查看收益和提现?
                    </a>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Page.Content>
    );
  }
}

export default Affiliate;
